











































































import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import { Settings, TenantSettings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import { Format } from "@/shared/core/helpers/formatHelper";
import store from "@/shared/core/store";
import HomeHero from "@/shared/components/home/HomeHero.vue";
import HomeSection from "@/shared/components/home/HomeSection.vue";
import HomeAbout from "@/shared/components/home/HomeAbout.vue";
import HomeFeaturedTherapist from "@/shared/components/home/HomeFeaturedTherapist.vue";
import HomeServicesCarousel from "@/shared/components/home/HomeServicesCarousel.vue";
import HomeFeaturedProducts from "@/shared/components/home/HomeFeaturedProducts.vue";
import HomeClassesCarousel from "@/shared/components/home/HomeClassesCarousel.vue";
import Testimonial from "@/shared/components/testimonial/testimonial.vue";
import LastPosts from "@/shared/components/lastPosts/lastPosts.vue";
import Banners from "@/shared/components/banners/banners.vue";

@Component({
  components: {
    HomeHero,
    Banners,
    HomeSection,
    HomeAbout,
    HomeFeaturedTherapist,
    HomeServicesCarousel,
    HomeFeaturedProducts,
    HomeClassesCarousel,
    Testimonial,
    LastPosts,
  },
})
export default class IndexPage extends Vue {
  settings: TenantSettings = {};
  galleryData: any[] = [];
  aboutImages: string[] = [];
  serviceSlides: any[] = [];
  showTherapists: boolean = false;
  showAbout: boolean = false;
  showServices: boolean = false;
  showFeaturedProducts: boolean = false;
  showTestimonials: boolean = false;
  showClasses: boolean = false;
  showPosts: boolean = false;
  featuredProductCount: number = 0;

  async mounted() {
    this.settings = store.state.settings;
    await this.loadGallery();
    this.aboutImages = this.galleryData
      .map((img) => img.url)
      .filter((url) => !!url)
      .slice(0, 10);
    this.showAbout = this.aboutImages.length >= 1;
    await this.loadServiceSlides();
    this.showServices = this.serviceSlides.length > 0;
    this.updateShopVisibility();
  }

  async loadGallery() {
    const dbGallery = localStorage.getItem(Settings.Prefix + "all-gallery");
    if (dbGallery !== null) {
      this.galleryData = JSON.parse(dbGallery);
      return;
    }

    const url = `${Settings.HostName}/api/fileuploads/open-list?parentName=CZConfig&parentId=1&category=CzGallery&limit=10`;
    const data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash getting gallery");
      return;
    }

    this.galleryData = data.data.map((image: any) => ({
      ...image,
      url: this.settings.Uploads + "/CzConfig/CzGallery/" + image.url,
    }));
    localStorage.setItem(
      Settings.Prefix + "all-gallery",
      JSON.stringify(this.galleryData)
    );
  }

  async loadServiceSlides() {
    const url = `${Settings.HostName}/api/publicbookings/booking-types-list`;
    const data = await new CrudService().httpGet(url);
    if (data == null || data.model == null || !data.ok) {
      console.error("Crash getting booking types for services");
      return;
    }
    this.serviceSlides = this.buildServiceSlides(data.model);
  }

  onTherapistsLoaded(count: number) {
    this.showTherapists = count > 0;
  }

  onProductsLoaded(count: number) {
    this.featuredProductCount = count;
    this.updateShopVisibility();
  }

  onTestimonialsLoaded(count: number) {
    this.showTestimonials = count > 0;
  }

  onClassesLoaded(count: number) {
    this.showClasses = count > 0;
  }

  onPostsLoaded(count: number) {
    this.showPosts = count > 0;
  }

  updateShopVisibility() {
    const hasShopSetting =
      this.settings !== null &&
      this.settings !== undefined &&
      this.settings.HasShop === true;
    this.showFeaturedProducts = hasShopSetting && this.featuredProductCount > 0;
  }

  get isAboutFirst() {
    return this.showAbout;
  }

  get isTherapistFirst() {
    return !this.showAbout && this.showTherapists;
  }

  get isServicesFirst() {
    return !this.showAbout && !this.showTherapists && this.showServices;
  }

  get isFeaturedFirst() {
    return (
      !this.showAbout &&
      !this.showTherapists &&
      !this.showServices &&
      this.showFeaturedProducts
    );
  }

  get isTestimonialsFirst() {
    return (
      !this.showAbout &&
      !this.showTherapists &&
      !this.showServices &&
      !this.showFeaturedProducts &&
      this.showTestimonials
    );
  }

  get isClassesFirst() {
    return (
      !this.showAbout &&
      !this.showTherapists &&
      !this.showServices &&
      !this.showFeaturedProducts &&
      !this.showTestimonials &&
      this.showClasses
    );
  }

  get isPostsFirst() {
    return (
      !this.showAbout &&
      !this.showTherapists &&
      !this.showServices &&
      !this.showFeaturedProducts &&
      !this.showTestimonials &&
      !this.showClasses &&
      this.showPosts
    );
  }

  buildServiceSlides(items: any[]) {
    const slides: any[] = [];
    if (!Array.isArray(items)) {
      return slides;
    }
    const featured = items.filter((item) => item && item.showInMainPage === true);
    const source = featured.length > 0 ? featured : items;
    for (const item of source) {
      if (slides.length >= 5) {
        break;
      }
      if (!item || item.id === null || item.id === undefined) {
        continue;
      }
      const title = item.description ? item.description : "";
      const subtitle = item.category ? item.category : "";
      const description = item.extendedDescription ? item.extendedDescription : "";
      const price =
        item.grossPrice !== null && item.grossPrice !== undefined
          ? Format.formatCurrency(String(item.grossPrice))
          : "";
      const ctaUrl =
        item.bookingByPlace === true
          ? "/bookings-byplace/" + item.id
          : "/bookings/" + item.id;
      slides.push({
        image: this.getServiceImagePath(item.image),
        title,
        subtitle,
        description,
        price,
        ctaText: String(this.$t("Reserve appointment")),
        ctaUrl,
        ctaHref: "",
      });
    }
    return slides;
  }

  getServiceImagePath(img: string) {
    if (img === null || img === undefined || img === "") {
      return this.settings.Uploads + "/" + this.settings.Mainlogo;
    }
    return this.settings.Uploads + "/" + img;
  }
}
